var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowv2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 43.1988C34.6046 43.1988 43.2008 34.6027 43.2008 23.9988C43.2008 13.395 34.6046 4.79883 24.0008 4.79883C13.3969 4.79883 4.80078 13.395 4.80078 23.9988C4.80078 34.6027 13.3969 43.1988 24.0008 43.1988Z",
    fill: "#4FC814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9381 17.2206C26.3758 16.6582 25.464 16.6582 24.9016 17.2206C24.3393 17.7829 24.3393 18.6947 24.9016 19.2571L28.2034 22.5588H16.3199C15.5246 22.5588 14.8799 23.2035 14.8799 23.9988C14.8799 24.7941 15.5246 25.4388 16.3199 25.4388H28.2034L24.9016 28.7406C24.3393 29.3029 24.3393 30.2147 24.9016 30.7771C25.464 31.3394 26.3758 31.3394 26.9381 30.7771L32.6981 25.0171C33.2605 24.4547 33.2605 23.5429 32.6981 22.9806L26.9381 17.2206Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowv2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Arrowv2.f90c8772.svg";
export { ForwardRef as ReactComponent };